<template functional>
  <div class="page-title">
    <span>{{ props.breadcrumbOuter }}</span>
    <span> / </span>
    
    <router-link :to="{ name: props.breadcrumbTo }" v-if="!props.breadcrumbIsHistory">
      <span class="link uppercase-text">{{ props.breadcrumbToTitle }}</span>
    </router-link>
  
    <!-- If user is coming from /history render -->
    <router-link :to="{ name: props.breadcrumbTo }" v-if="props.breadcrumbIsHistory">
      <span class="link uppercase-text">
        {{ props.breadcrumbToTitle }}
      </span>
    </router-link>
    
    <span> / </span>
    <span class="text">{{ props.breadcrumbInner }}</span>
  </div>
</template>

<script>
  export default {
    name: "FPBreadcrumb"
  }
</script>
